import { useEffect } from "react";
import PropTypes from "prop-types";
import { Header, Icon, Tab } from "semantic-ui-react";
import { Toasts } from "hireart-components";
import "./server-error.scss";

const memoizedFlashErrorMessage = () => {
  let alreadyFlashed = false;

  return () => {
    if (alreadyFlashed) {
      return;
    }
    alreadyFlashed = true;
    Toasts.error("Oops, something went wrong");
  };
};

const errorMessage = memoizedFlashErrorMessage();

const ServerError = ({
  headerText = "Uh-oh — something's not right...",
  message = "Something happened on our end. We're working to fix it as soon as possible — just sit tight and everything should be back up to normal soon. If you'd like, try refreshing the page.",
}) => {
  useEffect(() => {
    errorMessage();
  }, []);

  return (
    <div className="server-error">
      <Tab.Pane>
        <Header as="h3">
          <Icon name="exclamation triangle" />
          {headerText}
        </Header>
        <p className="description">{message}</p>
      </Tab.Pane>
    </div>
  );
};

ServerError.propTypes = {
  message: PropTypes.string,
  headerText: PropTypes.string,
};

export default ServerError;
